import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const MultiLanguage = makeShortcode("MultiLanguage");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`In the same way that every person can have `}<a parentName="p" {...{
        "href": "/docs/getting-started/person-properties"
      }}>{`properties`}</a>{` associated with them, every group can have properties associated with it.`}</p>
    <p>{`Continuing with the previous example of using `}<inlineCode parentName="p">{`company`}</inlineCode>{` as our group type, we'll add `}<inlineCode parentName="p">{`company_name`}</inlineCode>{`, `}<inlineCode parentName="p">{`date_joined`}</inlineCode>{`, and `}<inlineCode parentName="p">{`subscription`}</inlineCode>{` as additional properties.`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Note:`}</strong>{` You must include at least one group property for a group to be visible in the "Persons & Groups" tab.`}</p>
    </blockquote>
    <MultiLanguage mdxType="MultiLanguage">
      <pre><code parentName="pre" {...{
          "className": "language-js-web"
        }}>{`posthog.group('company', 'company_id_in_your_db', {
    name: 'PostHog',
    subscription: "subscription",
    date_joined: '2020-01-23'
});
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-python"
        }}>{`posthog.group_identify('company', 'company_id_in_your_db', {
    'name': 'PostHog',
    'subscription': 'subscription',
    'date_joined': '2020-01-23'
})
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-go"
        }}>{`client.Enqueue(posthog.GroupIdentify{
    Type: "company",
    Key:  "company_id_in_your_db",
    Properties: posthog.NewProperties().
        Set("name", "PostHog").
        Set("subscription", "subscription").
        Set("date_joined", "2020-01-23"),
})
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-node"
        }}>{`posthog.groupIdentify({
    groupType: 'company',
    groupKey: 'company_id_in_your_db',
    properties: {
        name: 'PostHog',
        subscription: "subscription",
        date_joined: '2020-01-23'
    }
})
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-php"
        }}>{`PostHog::groupIdentify([
    'groupType' => 'company',
    'groupKey' => 'company_id_in_your_db',
    'properties' => ['name' => 'PostHog', 'subscription' => 'premium', 'date_joined' => '2020-01-23']
]);
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-segment"
        }}>{`analytics.group('company_id_in_your_db', {
    "name": "PostHog",
    "subscription": "subscription",
    "date_joined": "2020-01-23"
})

\`\`\`bash
curl -v -L --header "Content-Type: application/json" -d '{
    "api_key": "<ph_project_api_key>",
    "event": "$groupidentify",
    "properties": {
        "distinct_id": "company_id_in_your_db",
        "$group_type": "company",
        "$group_key": "company_id_in_your_db",
        "$group_set": {
            "name": "PostHog",
            "subscription": "premium",
            "date_joined": "2020-01-23"
        }
    }
}' <ph_client_api_host>/capture/
`}</code></pre>
    </MultiLanguage>
    <p>{`Properties on groups behave in the same way as properties on `}<a parentName="p" {...{
        "href": "/docs/data/persons"
      }}>{`persons`}</a>{`. They can also be used within experiments and feature flags to rollout features to specific groups.`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Note:`}</strong>{` The PostHog UI identifies a group using the `}<inlineCode parentName="p">{`name`}</inlineCode>{` property. If the `}<inlineCode parentName="p">{`name`}</inlineCode>{` property is not found, it falls back to the group key.`}</p>
    </blockquote>
    <p>{`For more on implementing group analytics, check out our `}<a parentName="p" {...{
        "href": "/tutorials/frontend-vs-backend-group-analytics"
      }}>{`guide on frontend vs backend group analytics implementations`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      